// extracted by mini-css-extract-plugin
export default {"rating-container":"styles_rating-container__WHawS"};